import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { ControlIcons } from 'owa-control-icons';

/**
 * Get custom icon for special folders like inbox, drafts, sent, deleted, etc.
 * @param showNonSpecialFolderIcon Whether to show generic folder icon
 */
function getCustomIcon(folderId: string, showNonSpecialFolderIcon: boolean): string {
    switch (folderId) {
        case folderNameToId('inbox'):
            return ControlIcons.Inbox;

        case folderNameToId('sentitems'):
            return ControlIcons.Send;

        case folderNameToId('drafts'):
            return ControlIcons.Edit;

        case folderNameToId('deleteditems'):
            return ControlIcons.Delete;

        case folderNameToId('archive'):
            return ControlIcons.Archive;

        case folderNameToId('junkemail'):
            return ControlIcons.Blocked;

        case folderNameToId('scheduled'):
            return ControlIcons.Clock;
        case folderNameToId('notes'):
            return ControlIcons.QuickNote;
        default:
            break;
    }

    if (showNonSpecialFolderIcon) {
        return ControlIcons.FabricFolder;
    } else {
        return null;
    }
}

export default getCustomIcon;
